import React, { useMemo } from "react";
import { noop } from "lodash";
import allIcons from "@fdr/static-ui/Icons/icons";
import buildColor from "@fdr/static-ui/ColorPalette";
import AccountMenuLink from "@fdr/atomic-ui/_molecules/AccountMenuLink";
import { CrossApplication } from "@tvg/ts-types/CrossApp";
import { UnaryFn } from "@tvg/ts-types/Functional";
import { ProductLink, UnavailableText } from "./styled-components";

export type CrossProductDevices = "iOS" | "android";

function CrossProductLink({
  qaLabel = "cross-product",
  product,
  isAvailable = true,
  onOpenExternalLink = noop,
  userState
}: {
  product: CrossApplication;
  onOpenExternalLink: UnaryFn<CrossApplication, void>;
  qaLabel?: string;
  isAvailable?: boolean;
  userState?: string;
}) {
  const ProductIcon = {
    icon: allIcons[product.icon],
    color: isAvailable ? buildColor("blue", "D1") : buildColor("black")
  };

  return useMemo(
    () => (
      <ProductLink
        isAvailableForState={isAvailable}
        data-qa-label={`${qaLabel}-${product.productId}`}
      >
        <AccountMenuLink
          qaLabel={`item-${product.productId}`}
          linkText={product.title}
          leftIcon={ProductIcon}
          hideRightIcon={!isAvailable}
          onClick={() => onOpenExternalLink(product)}
          disabled={!isAvailable}
        />
        {!isAvailable && (
          <UnavailableText
            data-qa-label={`${qaLabel}-${product.productId}-unavailable-text`}
          >
            Unavailable {userState && `in ${userState}`}
          </UnavailableText>
        )}
      </ProductLink>
    ),
    [userState, product]
  );
}

export default CrossProductLink;
